class WidgetFormTrackerModule {
    splitLabels(labels) {
        return labels.split(",");
    }
    preferenceIsEmpty(preferences) {
        if (preferences === "") {
            return true;
        }
        return false;
    }

}
export default WidgetFormTrackerModule;


// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-form-tracker/widget/scripts/app-form-tracker.js